import { BookOpenCheckIcon, CalculatorIcon, FactoryIcon, GlobeIcon, ScaleIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Critical Minerals Technical Glossary',
    description: '150 essential mining, processing, battery, and economics terms explained.',
    icon: BookOpenCheckIcon,
  },
  {
    number: '2',
    title: 'Lithium Extraction Technology Comparison Guide',
    description: 'Visual comparison of hard-rock, brine, DLE, and alternative lithium recovery methods.',
    icon: ScaleIcon,
  },
  {
    number: '3',
    title: 'Lithium & Critical Minerals Calculation Handbook',
    description: '37 worked engineering examples covering chemical conversions, processing, and project economics.',
    icon: CalculatorIcon,
  },
  {
    number: '4',
    title: '12 Practical Lithium & Critical Minerals Industry Case Studies',
    description: 'Realistic mining, processing, battery, and project scenarios with technical analysis.',
    icon: FactoryIcon,
  },
  {
    number: '5',
    title: 'Global Critical Minerals Reference Atlas',
    description: '50 visual maps, regional profiles, and global supply chain resource sheets.',
    icon: GlobeIcon,
  },
];
